module.exports = __webpack_public_path__ + "img/shibumi.2d350cc6.svg";